export const menuList: ScmpPwaOnelineMenuAppConfig["list"] = {
  asia: [
    {
      entityId: "",
      isExternal: true,
      name: "Latest",
      urlAlias: "/live",
    },
    {
      entityId: "323045",
      entityUuid: "94de9d0d-5695-4d44-96d4-3d3e0f2cd73d",
      isExternal: true,
      name: "Asia",
      routeType: "Section",
      trackingName: "Twia",
      urlAlias: "/week-asia",
    },
    {
      entityId: "4",
      entityUuid: "08925cfe-01ce-4932-b9e2-be5b255efe63",
      isExternal: true,
      name: "China",
      routeType: "Section",
      urlAlias: "/news/china",
    },
    {
      entityId: "328461",
      entityUuid: "4aa8843f-16e2-4705-99d6-b53f22f6f75a",
      isExternal: true,
      name: "Economy",
      routeType: "Section",
      urlAlias: "/economy",
    },
    {
      entityId: "2",
      entityUuid: "465e2368-b5d9-4ab9-a471-e7ff921e6389",
      isExternal: true,
      name: "HK",
      routeType: "Section",
      urlAlias: "/news/hong-kong",
    },
    {
      entityId: "92",
      entityUuid: "718a073e-4006-4037-871e-6f6734324b4b",
      isExternal: true,
      name: "Business",
      routeType: "Section",
      urlAlias: "/business",
    },
    {
      entityId: "36",
      entityUuid: "068377d8-31c9-4a54-bf7f-47b4892b5308",
      isExternal: true,
      name: "Tech",
      routeType: "Section",
      urlAlias: "/tech",
    },
    {
      entityId: "94",
      entityUuid: "6354b86c-8bb8-47ef-b370-edf637245976",
      isExternal: true,
      name: "Lifestyle",
      routeType: "Section",
      urlAlias: "/lifestyle",
    },
    {
      entityId: "318202",
      entityUuid: "c3524c79-f0d5-48fd-b834-36a56894c672",
      isExternal: true,
      name: "People & Culture",
      routeType: "Section",
      urlAlias: "/news/people-culture",
    },
    {
      entityId: "5",
      entityUuid: "fc2e7dc2-9791-410a-906c-28ae8a6cf9db",
      isExternal: true,
      name: "World",
      routeType: "Section",
      urlAlias: "/news/world",
    },
    {
      entityId: "93",
      entityUuid: "75878f6f-55b9-4675-8384-7dfcf67cd6b1",
      isExternal: true,
      name: "Opinion",
      routeType: "Section",
      urlAlias: "/comment",
    },
    {
      entityId: "0",
      entityUuid: "0",
      isExternal: true,
      name: "Video",
      routeType: "Section",
      urlAlias: "/video",
    },
    {
      entityId: "95",
      entityUuid: "078620c2-f6d7-4b1f-872e-7b4083c87e38",
      isExternal: true,
      name: "Sport",
      routeType: "Section",
      urlAlias: "/sport",
    },
    {
      entityId: "71",
      entityUuid: "6905550f-cf81-405a-8a19-6ffd324a9bb0",
      isExternal: true,
      name: "PostMag",
      routeType: "Section",
      urlAlias: "/postmag",
    },
    {
      entityId: "72",
      entityUuid: "9891fb45-50fa-4d5c-9210-f8a2597dec09",
      isExternal: true,
      name: "Style",
      routeType: "Section",
      urlAlias: "/magazines/style",
    },
    {
      entityId: "",
      entityUuid: "",
      isExternal: false,
      name: "Games",
      routeType: "Section",
      urlAlias: "/games",
    },
  ],
  hk: [
    {
      entityId: "",
      isExternal: true,
      name: "Latest",
      urlAlias: "/live",
    },
    {
      entityId: "2",
      entityUuid: "465e2368-b5d9-4ab9-a471-e7ff921e6389",
      isExternal: true,
      name: "Hong Kong",
      routeType: "Section",
      urlAlias: "/news/hong-kong",
    },
    {
      entityId: "4",
      entityUuid: "08925cfe-01ce-4932-b9e2-be5b255efe63",
      isExternal: true,
      name: "China",
      routeType: "Section",
      urlAlias: "/news/china",
    },
    {
      entityId: "92",
      entityUuid: "718a073e-4006-4037-871e-6f6734324b4b",
      isExternal: true,
      name: "Business",
      routeType: "Section",
      urlAlias: "/business",
    },
    {
      entityId: "328461",
      entityUuid: "4aa8843f-16e2-4705-99d6-b53f22f6f75a",
      isExternal: true,
      name: "Economy",
      routeType: "Section",
      urlAlias: "/economy",
    },
    {
      entityId: "323045",
      entityUuid: "94de9d0d-5695-4d44-96d4-3d3e0f2cd73d",
      isExternal: true,
      name: "Asia",
      routeType: "Section",
      trackingName: "Twia",
      urlAlias: "/week-asia",
    },
    {
      entityId: "36",
      entityUuid: "068377d8-31c9-4a54-bf7f-47b4892b5308",
      isExternal: true,
      name: "Tech",
      routeType: "Section",
      urlAlias: "/tech",
    },
    {
      entityId: "94",
      entityUuid: "6354b86c-8bb8-47ef-b370-edf637245976",
      isExternal: true,
      name: "Lifestyle",
      routeType: "Section",
      urlAlias: "/lifestyle",
    },
    {
      entityId: "318202",
      entityUuid: "c3524c79-f0d5-48fd-b834-36a56894c672",
      isExternal: true,
      name: "People & Culture",
      routeType: "Section",
      urlAlias: "/news/people-culture",
    },
    {
      entityId: "5",
      entityUuid: "fc2e7dc2-9791-410a-906c-28ae8a6cf9db",
      isExternal: true,
      name: "World",
      routeType: "Section",
      urlAlias: "/news/world",
    },
    {
      entityId: "93",
      entityUuid: "75878f6f-55b9-4675-8384-7dfcf67cd6b1",
      isExternal: true,
      name: "Opinion",
      routeType: "Section",
      urlAlias: "/comment",
    },
    {
      entityId: "95",
      entityUuid: "078620c2-f6d7-4b1f-872e-7b4083c87e38",
      isExternal: true,
      name: "Sport",
      routeType: "Section",
      urlAlias: "/sport",
    },
    {
      entityId: "0",
      entityUuid: "0",
      isExternal: true,
      name: "Video",
      routeType: "Section",
      urlAlias: "/video",
    },
    {
      entityId: "71",
      entityUuid: "6905550f-cf81-405a-8a19-6ffd324a9bb0",
      isExternal: true,
      name: "PostMag",
      routeType: "Section",
      urlAlias: "/postmag",
    },
    {
      entityId: "72",
      entityUuid: "9891fb45-50fa-4d5c-9210-f8a2597dec09",
      isExternal: true,
      name: "Style",
      routeType: "Section",
      urlAlias: "/magazines/style",
    },
    {
      entityId: "",
      entityUuid: "",
      isExternal: false,
      name: "Games",
      routeType: "Section",
      urlAlias: "/games",
    },
  ],
  int: [
    {
      entityId: "",
      isExternal: true,
      name: "Latest",
      urlAlias: "/live",
    },
    {
      entityId: "4",
      entityUuid: "08925cfe-01ce-4932-b9e2-be5b255efe63",
      isExternal: true,
      name: "China",
      routeType: "Section",
      urlAlias: "/news/china",
    },
    {
      entityId: "328461",
      entityUuid: "4aa8843f-16e2-4705-99d6-b53f22f6f75a",
      isExternal: true,
      name: "Economy",
      routeType: "Section",
      urlAlias: "/economy",
    },
    {
      entityId: "2",
      entityUuid: "465e2368-b5d9-4ab9-a471-e7ff921e6389",
      isExternal: true,
      name: "HK",
      routeType: "Section",
      urlAlias: "/news/hong-kong",
    },
    {
      entityId: "323045",
      entityUuid: "94de9d0d-5695-4d44-96d4-3d3e0f2cd73d",
      isExternal: true,
      name: "Asia",
      routeType: "Section",
      trackingName: "Twia",
      urlAlias: "/week-asia",
    },
    {
      entityId: "92",
      entityUuid: "718a073e-4006-4037-871e-6f6734324b4b",
      isExternal: true,
      name: "Business",
      routeType: "Section",
      urlAlias: "/business",
    },
    {
      entityId: "36",
      entityUuid: "068377d8-31c9-4a54-bf7f-47b4892b5308",
      isExternal: true,
      name: "Tech",
      routeType: "Section",
      urlAlias: "/tech",
    },
    {
      entityId: "94",
      entityUuid: "6354b86c-8bb8-47ef-b370-edf637245976",
      isExternal: true,
      name: "Lifestyle",
      routeType: "Section",
      urlAlias: "/lifestyle",
    },
    {
      entityId: "318202",
      entityUuid: "c3524c79-f0d5-48fd-b834-36a56894c672",
      isExternal: true,
      name: "People & Culture",
      routeType: "Section",
      urlAlias: "/news/people-culture",
    },
    {
      entityId: "5",
      entityUuid: "fc2e7dc2-9791-410a-906c-28ae8a6cf9db",
      isExternal: true,
      name: "World",
      routeType: "Section",
      urlAlias: "/news/world",
    },
    {
      entityId: "93",
      entityUuid: "75878f6f-55b9-4675-8384-7dfcf67cd6b1",
      isExternal: true,
      name: "Opinion",
      routeType: "Section",
      urlAlias: "/comment",
    },
    {
      entityId: "0",
      entityUuid: "0",
      isExternal: true,
      name: "Video",
      routeType: "Section",
      urlAlias: "/video",
    },
    {
      entityId: "95",
      entityUuid: "078620c2-f6d7-4b1f-872e-7b4083c87e38",
      isExternal: true,
      name: "Sport",
      routeType: "Section",
      urlAlias: "/sport",
    },
    {
      entityId: "71",
      entityUuid: "6905550f-cf81-405a-8a19-6ffd324a9bb0",
      isExternal: true,
      name: "PostMag",
      routeType: "Section",
      urlAlias: "/postmag",
    },
    {
      entityId: "72",
      entityUuid: "9891fb45-50fa-4d5c-9210-f8a2597dec09",
      isExternal: false,
      name: "Style",
      routeType: "Section",
      urlAlias: "/magazines/style",
    },
    {
      entityId: "",
      entityUuid: "",
      isExternal: true,
      name: "Games",
      routeType: "Section",
      urlAlias: "/games",
    },
  ],
  us: [
    {
      entityId: "4",
      entityUuid: "08925cfe-01ce-4932-b9e2-be5b255efe63",
      isExternal: true,
      name: "China",
      routeType: "Section",
      urlAlias: "/news/china",
    },
    {
      entityId: "328461",
      entityUuid: "4aa8843f-16e2-4705-99d6-b53f22f6f75a",
      isExternal: true,
      name: "Economy",
      routeType: "Section",
      urlAlias: "/economy",
    },
    {
      entityId: "2",
      entityUuid: "465e2368-b5d9-4ab9-a471-e7ff921e6389",
      isExternal: true,
      name: "HK",
      routeType: "Section",
      urlAlias: "/news/hong-kong",
    },
    {
      entityId: "323045",
      entityUuid: "94de9d0d-5695-4d44-96d4-3d3e0f2cd73d",
      isExternal: true,
      name: "Asia",
      routeType: "Section",
      trackingName: "Twia",
      urlAlias: "/week-asia",
    },
    {
      entityId: "92",
      entityUuid: "718a073e-4006-4037-871e-6f6734324b4b",
      isExternal: true,
      name: "Business",
      routeType: "Section",
      urlAlias: "/business",
    },
    {
      entityId: "36",
      entityUuid: "068377d8-31c9-4a54-bf7f-47b4892b5308",
      isExternal: true,
      name: "Tech",
      routeType: "Section",
      urlAlias: "/tech",
    },
    {
      entityId: "94",
      entityUuid: "6354b86c-8bb8-47ef-b370-edf637245976",
      isExternal: true,
      name: "Lifestyle",
      routeType: "Section",
      urlAlias: "/lifestyle",
    },
    {
      entityId: "318202",
      entityUuid: "c3524c79-f0d5-48fd-b834-36a56894c672",
      isExternal: true,
      name: "People & Culture",
      routeType: "Section",
      urlAlias: "/news/people-culture",
    },
    {
      entityId: "5",
      entityUuid: "fc2e7dc2-9791-410a-906c-28ae8a6cf9db",
      isExternal: true,
      name: "World",
      routeType: "Section",
      urlAlias: "/news/world",
    },
    {
      entityId: "93",
      entityUuid: "75878f6f-55b9-4675-8384-7dfcf67cd6b1",
      isExternal: true,
      name: "Comment",
      routeType: "Section",
      urlAlias: "/comment",
    },
    {
      entityId: "0",
      entityUuid: "0",
      isExternal: true,
      name: "Video",
      routeType: "Section",
      urlAlias: "/video",
    },
    {
      entityId: "95",
      entityUuid: "078620c2-f6d7-4b1f-872e-7b4083c87e38",
      isExternal: true,
      name: "Sport",
      routeType: "Section",
      urlAlias: "/sport",
    },
    {
      entityId: "71",
      entityUuid: "6905550f-cf81-405a-8a19-6ffd324a9bb0",
      isExternal: true,
      name: "PostMag",
      routeType: "Section",
      urlAlias: "/postmag",
    },
    {
      entityId: "72",
      entityUuid: "9891fb45-50fa-4d5c-9210-f8a2597dec09",
      isExternal: true,
      name: "Style",
      routeType: "Section",
      urlAlias: "/magazines/style",
    },
  ],
};
